var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 51,
    viewBox: "0 0 512 512.001",
    width: 51,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#e27484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456.836 0H55.168C24.75 0 0 24.746 0 55.168V376.5c0 30.418 24.75 55.168 55.168 55.168h84.285l-54.726 54.727c-5.856 5.855-5.856 15.355 0 21.21A14.955 14.955 0 0 0 95.332 512c3.84 0 7.68-1.465 10.61-4.395l75.937-75.937H330.12l75.938 75.937A14.955 14.955 0 0 0 416.664 512c3.84 0 7.68-1.465 10.61-4.395 5.855-5.855 5.855-15.351 0-21.21l-54.731-54.727h84.289c30.418 0 55.164-24.75 55.164-55.168V55.168C512 24.746 487.254 0 456.836 0zM482 376.5c0 13.879-11.29 25.168-25.164 25.168H55.168C41.289 401.668 30 390.378 30 376.5V55.168C30 41.289 41.29 30 55.168 30h401.668C470.71 30 482 41.29 482 55.168zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m359.902 202.844-160.668-92.762a15 15 0 0 0-22.5 12.992v185.52c0 5.36 2.86 10.308 7.5 12.992 2.32 1.34 4.91 2.008 7.5 2.008s5.18-.668 7.5-2.008l160.668-92.766a14.997 14.997 0 0 0 0-25.976zm-153.168 79.77v-133.56l115.668 66.778zm0 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout2);
export default __webpack_public_path__ + "static/media/about2.4c870be069add873bf52554c1ea64bb7.svg";
export { ForwardRef as ReactComponent };